import type {
  RbacAuditEntryDto, RbacMatrixDto, SetOverrideRequest, StaffLevel, UserDto, UserPermissionsDto,
} from '@ledokol/contracts'
import { api } from './client'

/** Слой 6 — API панели «Роли и доступы» (под rbac.manage). */

export async function fetchRbacMatrix(): Promise<RbacMatrixDto> {
  const r = await api.get<RbacMatrixDto>('/rbac/matrix')
  return r.data
}

export async function fetchUserPermissions(userId: string): Promise<UserPermissionsDto> {
  const r = await api.get<UserPermissionsDto>(`/users/${userId}/permissions`)
  return r.data
}

export async function setUserOverride(
  userId: string,
  key: string,
  effect: SetOverrideRequest['effect'],
): Promise<UserPermissionsDto> {
  const r = await api.put<UserPermissionsDto>(`/users/${userId}/permissions/${key}`, { effect })
  return r.data
}

export async function fetchRbacAudit(limit = 50): Promise<RbacAuditEntryDto[]> {
  const r = await api.get<RbacAuditEntryDto[]>('/rbac/audit', { params: { limit: String(limit) } })
  return r.data
}

/** Слой 5 — применить шаблон грейда (кнопка «Применить уровень» в редакторе). */
export async function applyLevelPreset(userId: string, level: StaffLevel): Promise<UserDto> {
  const r = await api.post<UserDto>(`/users/${userId}/apply-level-preset`, { level })
  return r.data
}
